module.exports = __webpack_public_path__ + "assets/img/nav-item-1-active-73e08605.png";